import { memo } from "react"
import type { FC, NamedExoticComponent, ReactElement } from "react"

import { buildCssClassName, propsAreEqual } from "@/3514/utils"

import { CoachingChatProvider as Provider } from "./context"
import { withCoachingChatEntityInitiatedGuard as withInitiated } from "./guards"
import { coachingChatStyles as chatStyles } from "./styles"
import type { TCoachingChatConfig as TChatConfig } from "./types"

type TProps = {
    wrapperClassName?: string
    config: TChatConfig
}

const { entity: classes } = chatStyles

const Entity: FC<TProps> = ({ wrapperClassName = String(), config }: TProps): ReactElement => (
    <section className={buildCssClassName(classes.section(), { [wrapperClassName]: wrapperClassName })}>
        <Provider config={config} />
    </section>
)

const MemoizedEntity: NamedExoticComponent<TProps> = memo(Entity, propsAreEqual)

const GuardedEntity: FC<TProps> = withInitiated(MemoizedEntity)

GuardedEntity.displayName = "CoachingChatEntity"

export { GuardedEntity as CoachingChatEntity }
